module.exports = __webpack_public_path__ + "img/dep_candyandgum@2x.32dde33e.png";